import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import Badge from "Utils/Badge/Badge";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { DetalleCierreMensualApi } from "../api/DetalleCierreMensualApi";
import { ObservacionesDelPeriodo } from "./ObservacionesDelPeriodo";
import { ResumenExistenciaContenido } from "../../../../components/Existencia/ResumenExistenciaContenido";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import {
    TIPO_BODEGA,
    cierreDelPeriodo,
    estadoPeriodoCierre,
} from "../../../../helpers/tiposCierreMensual";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";

// Reporte de un período ya cerrado, tal como se entregó. No se edita: se
// reconstruye desde los documentos que cada cierre guardó.
// Se entra por un cierre concreto, pero se muestra el formato completo del
// período: es una sola hoja impresa, y la mitad que todavía no se cerró aparece
// rotulada como pendiente
export const ContenidoCierreMensual = ({ cierreId, onRegresar }) => {
    const [cierre, setCierre] = useState(null);

    const { getCierreMensual, obtenerReporteExcel, cargando } =
        DetalleCierreMensualApi();

    const GetCierreMensual = async () => {
        try {
            const response = await getCierreMensual(cierreId);

            setCierre(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el cierre mensual",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setCierre(null);
        }
    };

    useEffect(() => {
        GetCierreMensual();
    }, [cierreId]);

    const ExportarCierreMensual = async () => {
        try {
            await obtenerReporteExcel(cierreId);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el reporte en Excel",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    // se entra por un cierre, pero el encabezado describe al período: sus datos
    // salen de las dos mitades y no de la que abrió la pantalla
    const cierresPeriodo = cierre ? cierre.cierres_periodo : [];

    // la fecha de corte la declara el cierre de bodega, así que falta mientras
    // esa mitad no se haya registrado
    const cierreBodega = cierreDelPeriodo(cierresPeriodo, TIPO_BODEGA);

    const fechaCorte = cierreBodega
        ? moment(cierreBodega.fecha_corte).format("DD/MM/YYYY HH:mm")
        : "N/A";

    const periodoCompleto = !!(cierre && cierre.periodo_completo);

    return (
        <div className="reporte-inventarios__tab-wrapper">
            <CardEmpty noShadow>
                <LoadMask loading={cargando} blur>
                    <div className="reporte-inventarios__table-header align-items-center">
                        <div className="formulario-fields-row">
                            <div className="formulario-field">
                                <label className="text-nowrap">
                                    Período de almacenes
                                </label>
                                <span className="text-nowrap mt-1">
                                    {cierre ? cierre.periodo : ""}
                                </span>
                            </div>

                            <div className="formulario-field">
                                <label className="text-nowrap">
                                    Fecha y hora de corte
                                </label>
                                <div className="text-nowrap mt-1">
                                    {cierre ? fechaCorte : ""}
                                </div>
                            </div>
                            <div className="formulario-field">
                                <label className="text-nowrap">
                                    Registrado por
                                </label>
                                <div className="text-nowrap mt-1">
                                    {cierre
                                        ? cierre.usuario_nombre || "No definido"
                                        : ""}
                                </div>
                            </div>
                            <div className="formulario-field">
                                <label className="text-nowrap">
                                    Estado del período
                                </label>
                                <div className="text-nowrap mt-1">
                                    {cierre && (
                                        <Badge
                                            {...estadoPeriodoCierre(
                                                cierresPeriodo,
                                            )}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="ml-auto formulario-fields-row flex-nowrap">
                            <div className="formulario-field">
                                <button
                                    className="btn btn-outline-dark mt-auto text-nowrap"
                                    onClick={onRegresar}
                                >
                                    Regresar
                                </button>
                            </div>
                            <div className="formulario-field">
                                <button
                                    className="btn btn-secondary mt-auto text-nowrap"
                                    onClick={ExportarCierreMensual}
                                    disabled={!cierre}
                                    title={
                                        periodoCompleto
                                            ? ""
                                            : "Uno de los dos cierres del período se mostrará como pendiente"
                                    }
                                >
                                    Exportar Excel
                                </button>
                            </div>
                        </div>
                    </div>

                    {cierre && (
                        <React.Fragment>
                            <ResumenExistenciaContenido
                                resumen={cierre.resumen || {}}
                            />

                            <ObservacionesDelPeriodo
                                cierres={cierre.cierres_periodo || []}
                            />
                        </React.Fragment>
                    )}
                </LoadMask>
            </CardEmpty>
        </div>
    );
};
